import { render, staticRenderFns } from "./TaskRow.vue?vue&type=template&id=9193dde8&scoped=true"
import script from "./TaskRow.vue?vue&type=script&lang=js"
export * from "./TaskRow.vue?vue&type=script&lang=js"
import style0 from "./TaskRow.vue?vue&type=style&index=0&id=9193dde8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9193dde8",
  null
  
)

export default component.exports